import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UrlHighlightDirective } from './url-highlight.directive';
import { UrlsReplacingSearchComponent } from './urls-replacing-search.component';
import { P500UIFormFieldsModule, P500UIIconsModule, P500UIProgressModule, P500UITooltipModule } from '@platform500services/p500-ui-kit';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';

@NgModule({
  declarations: [UrlHighlightDirective, UrlsReplacingSearchComponent],
  imports: [
    CommonModule,
    P500UIFormFieldsModule,
    ReactiveFormsModule,
    P500UIProgressModule,
    P500UIIconsModule,
    P500UITooltipModule,
    RouterLink,
  ],
  exports: [UrlsReplacingSearchComponent],
})
export class UrlReplacingSearchModule {}
